let RESIDENT_TYPE = {
	NON_RESIDENTIAL: {
		code: "0",
		label: "common.typeList.resident.nonResidential"
	},
	RESIDENTIAL: {
		code: "1",
		label: "common.typeList.resident.residential"
	}
}

export default RESIDENT_TYPE
